import { useDispatch } from 'react-redux';
import { setErrorMessage } from '../store/errorSlice';
import { setQrCode } from '../store/photoSlice';
import { convertBlobToBase64 } from '../utils/fileUtils';
import { uploadPhoto } from '../service/api.v2.service';

export const useQRCodeUpload = (blockCode: string) => {
  const dispatch = useDispatch();

  const uploadMediaAndGenerateQR = async (
    imageFile: File,
    videoFiles: File[],
    frameId: number,
    logoUrl: string,
    color: string
  ): Promise<void> => {
    try {
      const qrCodeBlob = await uploadPhoto(imageFile, videoFiles, frameId, null, logoUrl, color);

      const qrCodeBase64 = await convertBlobToBase64(qrCodeBlob);

      dispatch(setQrCode(qrCodeBase64));
    } catch (error) {
      const err = error as Error;
      dispatch(
        setErrorMessage({
          errorMessage: err.message,
          errorContent: '알 수 없는 오류가 발생했어요.',
          messageDuration: null,
        })
      );
    }
  };

  return {
    uploadMediaAndGenerateQR,
  };
};
